<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">{{ data.header }}</div>
    <div class="modal-body">
      <div class="files-table-scroll">
        <table class="cl-table-data cl-table-data-light">
          @if (encodes$ | async; as encodes) {
            <thead>
              <tr>
                @if (encodes.length > 0 && encodes.some(f => canDownload(f))) {
                  <th class="cl-table-head cl-table-head-checkbox cl-p-tiny" width="1%">
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input"
                          aria-label="Select all downloadable files"
                          [checked]="isAllSelected(encodes)"
                          [indeterminate]="isIndeterminate(encodes)"
                          (change)="toggleAll(encodes)"/>
                    </div>
                  </th>
                } 
                <th class="cl-table-head cl-p-tiny ">
                  Filename
                </th>
                <th class="cl-table-head cl-p-tiny ">
                  Size
                </th>
                <th class="cl-table-head cl-p-tiny ">
                  Last Modified
                </th>
                <th class="cl-table-head cl-p-tiny "></th>
              </tr>
            </thead>
          
            <tbody>
              @if (encodes.length > 0) {
                @for (file of encodes; track file) {
                  <tr [class.cl-tr-inflight]="renameInflight() === file.id || deleteInflight() === file.id">
                    @if (canDownload(file)) {
                      <td width="1%" class="cl-td-checkbox">
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input"
                              aria-label="Select {{ file.name }}"
                              [checked]="selection.isSelected(file)"
                              (change)="selection.toggle(file)"/>
                        </div>
                      </td>
                    }
                    <td>
                      @if (editingId === file.id) {
                        <input type="text" class="form-control form-control-sm"
                              [(ngModel)]="editingName"
                              [disabled]="renameInflight() === file.id"
                              (keyup.enter)="saveRename(file)"
                              (keyup.escape)="cancelRename()" />
                      } @else {
                        @if (renameInflight() === file.id || deleteInflight() === file.id) {
                          <span><i class="fas fa-spinner fa-spin"></i> {{ file.name }}</span>
                        } @else {
                          {{ file.name }}
                          @if (zipFailures().get(file.id); as reason) {
                            <span class="cl-badge cl-badge-sm cl-color-brick"
                                title="Failed to include in zip download: {{ reason }}. Use Download to retry.">
                              Failed
                            </span>
                          }
                        }
                      }
                    </td>
                    <td class="cl-font-monospace text-end">
                      {{ file.size | fileSize }}
                    </td>
                    <td class="cl-td-time">
                      {{ file.last_modified | cldate }}
                    </td>
                    <td class="cl-td-links">
                      @if (editingId === file.id) {
                        <a class="cl-a-btn cl-a-primary" role="button"
                          [class.cl-a-disabled]="renameInflight() === file.id"
                          [class.cl-a-spinner]="renameInflight() === file.id"
                          (click)="saveRename(file)">Save</a>
                        <a class="cl-a-btn" role="button"
                          [class.cl-a-disabled]="renameInflight() === file.id"
                          (click)="cancelRename()">Cancel</a>
                      } @else if (deleteConfirmId === file.id) {
                        <span class="cl-text-danger">Delete?</span>
                        <a class="cl-a-btn cl-a-danger" role="button" (click)="deleteEncode(file)">Confirm</a>
                        <a class="cl-a-btn" role="button" (click)="cancelDelete()">Cancel</a>
                      } @else {
                        @if (canDownload(file)) {
                          <a class="cl-a-btn cl-a-primary" role="button" (click)="download(file)">Download</a>
                        }
                        @if (canRename(file)) {
                          <a class="cl-a-btn cl-a-primary" role="button" (click)="startRename(file)">Rename</a>
                        }
                        <a class="cl-a-btn cl-a-primary" role="button" (click)="confirmDelete(file)">Delete</a>
                      }
                    </td>
                  </tr>
                }
              } @else {
                <tr class="cl-tr-no-data">
                  <td colspan="100">No encodes available. Please wait for encodes to finish.</td>
                </tr>
              }
            </tbody>
          } @else {
            <td colspan="100" style="text-align: center">
              <div class="cl-spinner">
                Loading ...<i class="fas fa-spinner fa-spin"></i>
              </div>
            </td>
          }

        </table>
      </div>
    </div>
    <div class="modal-footer">
      <span class="modal-footer-left cl-spacing-box cl-spacing-none">
        <button type="button" class="btn cl-color-secondary it-ok"
          (click)="dialogRef.close();">
          <span>Close</span>
        </button>
      </span>
      <span class="modal-footer-center cl-spacing-box cl-spacing-none">
        @if (zipProgress(); as progress) {
          <p class="cl-p-small mt-4">Downloading {{ progress.done }} / {{ progress.total }}</p>
        }
      </span>
      <span class="modal-footer-right cl-spacing-box cl-spacing-none">
        @if (encodes$ | async; as encodes) {
          @if (encodes.length > 0 && encodes.some(f => canDownload(f))) {
            <button type="button" class="btn cl-color-primary"
              [class.cl-btn-spinner]="zipInflight()"
              [disabled]="selection.selected.length === 0 || zipInflight()"
              (click)="downloadSelectedAsZip(selection.selected)">
              <span>Download selected ({{ selection.selected.length }})</span>
            </button>
          }
        }
      </span>
    </div>
  </div>
</div>
